export function useAnalytics(e) {
  e.preventDefault();

  try {
    ga("send", {
      hitType: "event",
      eventCategory: "Actions",
      eventAction: e.target.dataset.action,
      eventLabel: e.target.dataset.label
    });
  } finally {
    setTimeout(() => {
      window.location.href = e.target.getAttribute("href");
    }, 100);
  }
}